import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { TextField } from 'formik-mui'
import I18n from 'i18n-js'
import { PropTypes } from 'prop-types'
import { PureComponent } from 'react'
import styled from 'styled-components'
import * as Yup from 'yup'

import { Button, Form } from '@src/components/shared'
import AppConfig from '@src/config/AppConfig'
import Breakpoints from '@src/lib/Breakpoints'
import LinkChild from '@src/lib/LinkChild'
import { connect, actions } from '@src/stores'
import selectors from '@src/stores/selectors'

const StyledFooter = styled.footer`
  display: flex;
  justify-content: center;
  flex-direction: column;
  & > button:not(:last-child),
  & > a:not(:last-child) {
    margin-bottom: 15px;
    @media (min-width: ${Breakpoints.phone}) {
      margin-bottom: 0;
    }
  }
  @media (min-width: ${Breakpoints.phone}) {
    justify-content: space-between;
    flex-direction: row;
  }
`

const StyledFooterWrapper = styled.div`
  flex: 1;
`

const formFields = [
  {
    component: TextField,
    label: I18n.t('shared.emailAddress'),
    name: 'email',
    helpText: I18n.t('auth.forgotPasswordHelp'),
    type: 'email',
    validation: Yup.string().email().required(),
  },
]

export class ForgotPasswordForm extends PureComponent {
  onSubmit({ email }) {
    this.props.resetPassword({
      email,
      redirect_url: AppConfig.CP_BASE + AppConfig.RESET_PASSWORD_REDIRECT_PATH,
    })
  }
  render() {
    return (
      <>
        <Typography color={'secondary'} varianant={'p'}>
          {I18n.t('auth.forgotPasswordHelp')}
        </Typography>
        <Form fields={formFields} onSubmit={this.onSubmit.bind(this)}>
          <StyledFooterWrapper>
            <StyledFooter>
              <LinkChild to={'/login'}>
                <Link>{I18n.t('shared.cancel')}</Link>
              </LinkChild>

              <Button
                buttonStyle={'primary'}
                disabled={this.props.resetPasswordIsPending}
                loading={this.props.resetPasswordIsPending}
                type={'submit'}
                width={'small'}
              >
                {I18n.t('auth.sendResetEmail')}
              </Button>
            </StyledFooter>
          </StyledFooterWrapper>
        </Form>
      </>
    )
  }
}

ForgotPasswordForm.propTypes = {
  resetPassword: PropTypes.func,
  resetPasswordIsPending: PropTypes.bool,
}

export default connect(
  (state) => ({
    ...selectors.auth.selectIsResetPasswordPending(state),
  }),
  {
    resetPassword: actions.auth.resetPassword,
  },
)(ForgotPasswordForm)
